import { useState } from 'react';

export default function RequestReasonModal({ product, onClose, onSubmit, isSubmitting, organizationMode = false, quantity = 1 }) {
  const [reason, setReason] = useState('');
  const brandColor = '#e46809';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason.trim().length < 20) {
      alert("Please provide a meaningful reason with at least 20 characters.");
      return;
    }
    onSubmit(reason);
  };

  const calculateTotal = () => {
    if (!product || !product.price) return 0;
    return product.price * quantity;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl p-8 w-full max-w-2xl border border-slate-700 max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          {organizationMode ? 'Organization Request: ' : 'Request: '}{product.name}
        </h2>
        
        {organizationMode && quantity > 1 && (
          <div className="mt-2 bg-blue-50 dark:bg-blue-900/50 p-3 rounded-md">
            <p className="text-blue-800 dark:text-blue-200 text-sm">
              <strong>Quantity:</strong> {quantity} units
              <br />
              <strong>Total Value:</strong> ₦{calculateTotal().toLocaleString()}
            </p>
          </div>
        )}

        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Final Step</p>
        
        <form onSubmit={handleSubmit} className="mt-4 space-y-4">
          <div>
            <label htmlFor="reason" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              {organizationMode 
                ? `Please explain why your organization needs ${quantity > 1 ? 'these items' : 'this item'} and how they will benefit your beneficiaries:`
                : 'Please explain why you need this item:'}
            </label>
            <textarea
              id="reason"
              rows="6"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
              placeholder={organizationMode 
                ? "Describe your organization's mission, the specific needs of your beneficiaries, and how these items will support your programs..."
                : "Explain your personal situation and how this item will help you..."}
              className="w-full mt-1 p-3 border border-gray-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-gray-800 dark:text-gray-200 resize-vertical"
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Minimum 20 characters. Current: {reason.length}
            </p>
          </div>

          <div className="p-3 rounded-md bg-yellow-50 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-200 text-sm">
            <strong>Collection Agreement:</strong> {organizationMode 
              ? 'An authorized representative must collect the items in person with the organization registration documents and valid ID.'
              : 'By submitting, you agree to collect this item in person with the valid ID you provided.'}
          </div>

          {organizationMode && (
            <div className="p-3 rounded-md bg-green-50 dark:bg-green-900/50 text-green-800 dark:text-green-200 text-sm">
              <strong>Organization Note:</strong> Your request will be reviewed based on your organization's registration status, 
              demonstrated need, and capacity to distribute items to beneficiaries effectively.
            </div>
          )}

          <div className="flex justify-end space-x-4 pt-4">
            <button 
              type="button" 
              onClick={onClose} 
              disabled={isSubmitting}
              className="py-2 px-4 bg-gray-200 dark:bg-slate-600 text-gray-800 dark:text-gray-200 font-semibold rounded-lg hover:bg-gray-300 dark:hover:bg-slate-500 disabled:opacity-50"
            >
              Cancel
            </button>
            <button 
              type="submit" 
              disabled={isSubmitting}
              className="py-2 px-4 text-white font-semibold rounded-lg disabled:opacity-50 flex items-center"
              style={{backgroundColor: brandColor}}
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Submitting...
                </>
              ) : (
                organizationMode ? 'Submit Organization Request' : 'Submit Request'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}